import HealthRecordListContainer from './HealthRecordListContainer';

export default HealthRecordListContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordListContainer/index.js